import React from "react";
import {GlobalContext} from "../../GlobalContext";
import {Button, Col, FormCheck, FormControl, Modal, ModalBody, ModalDialog, Row} from "react-bootstrap";
import {Glyph} from "./Glyph";
import ModalHeader from "react-bootstrap/ModalHeader";
import {OptionalSelect} from "./OptionalSelect";

export default class PickList extends React.Component {
    static contextType = GlobalContext;

    constructor(props) {
        super(props);
        this.state = {
            items: [],
            show: false
        }
    }

    componentDidMount() {
        this.loadList();
    }

    loadList = () => {
        this.context.cachedGet(`/pickList/${this.props.listName}`, 60)
            .then(d => {
                if (d && d.data) {
                    this.setState({items: d.data});
                }
            })
    }

    isItemSelected = (val) => {
        let controlValue = this.props.controlValue;
        if (controlValue) {
            if (Array.isArray(val) || typeof val == 'string') {
                return controlValue.includes(val);
            }
        }
        return false;
    }

    selectItem = (val) => {
        if (this.props.onItemSelected) {
            this.props.onItemSelected(val);
        }
    }

    deselectItem = (val) => {
        if (this.props.onItemDeselected) {
            this.props.onItemDeselected(val);
        }
    }

    itemChanged = (e) => {
        let val = e.target.value;
        if (e.target.checked) {
            this.selectItem(val);
        } else {
            this.deselectItem(val);
        }
    }

    render() {
        return this.props.dropdown ? <OptionalSelect options={this.state.items}
                                                     labelKey={"value"} valueKey={"value"}
                                                     noneLabel={"Select a value"}
                                                     canSelectNone={!this.props.required}
                                                     onChange={(e) => this.selectItem(e.target.value)}
                                                     value={this.props.value}/>
            : <>
            {this.props.button || <Glyph className={"clickable no-print"} name={"list-task"} onClick={() => this.setState({show: true})}/>}
            <Modal show={this.state.show} onHide={() => this.setState({show: false})} centered>
                <ModalHeader closeButton>Select Items</ModalHeader>
                <ModalBody>
                    {
                        this.state.items.map(i => <Row key={i.id}><Col>
                            <FormCheck type={"checkbox"} value={i.value} label={i.value} onChange={this.itemChanged} checked={this.isItemSelected(i.value)}/>
                        </Col></Row>)
                    }
                </ModalBody>
            </Modal>
        </>
    }

}